<!--
 * @Author: QiTianDaSheng
 * @Date: 2023-07-17 16:13:59
 * @Descripttion: 
 * @LastEditors: QiTianDaSheng
 * @LastEditTime: 2023-08-04 14:05:41
-->
<!-- 新闻资讯 -->
<template>
    <div class="newsInformationsBox">
        <div class="newsInfomations">
            <div class="newsTitle"></div>
            <div class="newsMain">
                <div class="newsItem" v-for="item in newsList" :key="item.id" @click="toNewsBody(item.id)">
                    <div class="datebox">
                        <div class="day">{{ item.day }}</div>
                        <span>|</span>
                        <div class="date">{{ item.date }}</div>
                    </div>
                    <div class="details">
                        <div class="detailsTitle">{{ item.newsTitle }}</div>
                        <div class="detailsInfo">{{ item.newsDigest }}</div>
                    </div>
                </div>
            </div>
            <div class="newsBtn">
                <div class="btn" @click="toNews">
                    <span>更多资讯</span>
                    <i></i>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getIndexNewsList } from '@/api/apis_news'
export default {
    data() {
        return {
            newsList: [],
        }
    },
    methods: {
        // 获取新闻列表
        async getNewsList() {
            const { data } = await getIndexNewsList({
                size: 6,
                issueChannel: 3,
            })

            if (data.code == 200) {
                data.data.map((item) => {
                    item.day = item.createTime.slice(8, 10)
                })
                data.data.map((item) => {
                    let year = item.createTime.slice(0, 4)
                    let mounth = item.createTime.slice(5, 7)
                    item.date = year + '年' + mounth + '月'
                })
                this.newsList = data.data
            }
        },
        // 跳转新闻列表页
        toNews() {
            let routeData = this.$router.resolve({ path: '/news' })
            window.open(routeData.href, '_blank')
        },
        // 跳转新闻详情页
        toNewsBody(id) {
            let routeData = this.$router.resolve({ path: '/news/body', query: { id: id } })
            window.open(routeData.href, '_blank')
        },
    },
    mounted() {
        this.getNewsList()
    },
}
</script>
<style scoped lang="scss">
.newsInformationsBox {
    width: 100%;
    background-color: #fff;
    margin-top: 50px;
    box-sizing: border-box;

    .newsInfomations {
        width: 1200px;
        margin: 0 auto;

        .newsTitle {
            width: 392px;
            height: 112px;
            margin: 0 auto;
            background: url('../../../assets/image/home/newsTitle.png');
            background-size: 100% 100%;
        }

        .newsMain {
            position: relative;
            margin-top: 32px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            &::after {
                content: '';
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;

                width: 1px;
                height: 91.38%;
                background-color: #d8d8d8;
            }

            .newsItem {
                width: 575px;
                flex: 0 0 575px;
                display: flex;
                justify-content: space-between;
                margin-bottom: 28px;
                cursor: pointer;

                &:hover{
                    .details{
                        .detailsTitle{
                            font-weight: 600;
                        }
                    }
                }

                .datebox {
                    flex: 0 0 130px;
                    height: 39px;
                    display: flex;
                    align-items: center;

                    span {
                        margin: 0 7px 0 6px;
                    }

                    .day {
                        height: 39px;
                        font-size: 28px;
                        font-family: Alibaba PuHuiTi 2-75 SemiBold, Alibaba PuHuiTi 20;
                        font-weight: 600;
                        color: #3d3d3d;
                        line-height: 39px;
                    }

                    .date,
                    span {
                        height: 28px;
                        font-size: 14px;
                        font-family: Alibaba PuHuiTi 2-55 Regular, Alibaba PuHuiTi 20;
                        font-weight: 400;
                        color: #767676;
                        line-height: 28px;
                    }
                }

                .details {
                    width: 404px;
                    text-align: left;
                    margin-left: 41px;

                    .detailsTitle {
                        width: 393px;
                        margin-bottom: 8px;
                        height: 28px;
                        font-size: 20px;
                        font-family: Alibaba PuHuiTi 2-65 Medium, Alibaba PuHuiTi 20;
                        // font-weight: 600;
                        font-weight: normal;
                        color: #1d2129;
                        line-height: 28px;

                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .detailsInfo {
                        width: 100%;
                        font-size: 14px;
                        font-family: Alibaba PuHuiTi 2-55 Regular, Alibaba PuHuiTi 20;
                        font-weight: 400;
                        color: #767676;
                        line-height: 28px;

                        display: -webkit-box;
                        overflow: hidden;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                    }
                }
            }
        }

        .newsBtn {
            margin: 36px 0 83px;

            .btn {
                display: flex;
                align-items: center;
                justify-content: center;

                width: 149px;
                height: 42px;
                margin: 0 auto;
                background: rgba(35, 35, 35, 0);
                border-radius: 6px;
                border: 1px solid #767676;

                cursor: pointer;

                span {
                    font-size: 16px;
                    font-family: Alibaba PuHuiTi 2-55 Regular, Alibaba PuHuiTi 20;
                    color: #767676;
                    line-height: 42px;
                }

                i {
                    margin-left: 5px;
                    width: 12px;
                    height: 9px;
                    background: url('../../../assets/image/home/newsArrowGrey.png');
                    background-size: 100% 100%;
                }

                &:hover {
                    background: rgba(35, 35, 35, 0);
                    border: 1px solid #be1a21;

                    span {
                        color: #be1a21;
                    }

                    i {
                        background: url('../../../assets/image/home/newsArrow.png');
                    }
                }
            }
        }
    }
}
</style>
